import {IHttpPromiseCallbackArg, IHttpResponse, IHttpService} from "angular";
import {SimpleModalService} from "../../../types/SimpleModalService";
import {UserDetails, UserDetailsResponse} from "../../types/SwiftTypes";
import {UserConfig} from "../../../types/UserConfig";

export class SwiftOnboardingService {

    public static id = "swiftOnboardingService";
    private prodBaseURl = "https://onboarding.tradefloor.com.au/applications";
    private stageBaseUrl = "http://s-tf-hn4-onboarding.swiftid-cloud.com.au/applications";

    /** @ngInject */
    public constructor(private $http: IHttpService,
                       private simpleModalService: SimpleModalService,
                       private readonly userConfig: UserConfig) {
    }

    public async getGUID() {
        const userProfile = this.userConfig.profile;
        const userDetails: UserDetails = {
            givenName: userProfile.givenName,
            surname: userProfile.surname ?? "",
            mobilePhone: userProfile.phone ?? "",
            emailAddress: this.userConfig.username,
            externalReference: this.userConfig.uid
        };
        try {
            const response: IHttpResponse<UserDetailsResponse> = await this.$http.post(`/tradefloor/api/swift/onboarding`, userDetails);
            return response.data.id;
        } catch (error) {
            console.error(error);
            this.displayError("Could not get id, please try again later.", "Thank you for your patience.");
        }
    }

    public async getApplicationId() {
        try {
            const response: IHttpResponse<UserDetailsResponse> = await this.$http.get(`/tradefloor/api/swift/onboarding/resume`);
            return response.data.id;
        } catch (error) {
            console.error(error);
            this.displayError("Your application is in progress", "Please wait for it to complete.");
        }
    }

    public redirectToSwift(guid: string) {
        window.location.href = this.isStage() ? `${this.stageBaseUrl}/individual/primaryapplicant?ipaId=${guid}` : `${this.prodBaseURl}/individual/primaryapplicant?ipaId=${guid}`;
    }

    public redirectToSwiftToResume(applicationId: string) {
        window.location.href = this.isStage() ? `${this.stageBaseUrl}/resume/${applicationId}` : `${this.prodBaseURl}/resume/${applicationId}`;
    }

    public isStage(): boolean {
        return window.location.href.indexOf("localhost") > -1 || window.location.href.indexOf("stage") > -1 || window.location.href.indexOf(
            "uat") > -1;
    }

    private displayError( title: string, body: string) {
        this.simpleModalService.error(null,
                                      `<pre>${body}</pre>`,
                                      title, "lg");
    }
}
